import React from 'react';
import LegalPage from '../components/LegalPage';
import { termsOfService } from '../data/legal';

export default function TermsOfServicePage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Terms of Service"
      updated={termsOfService.updated}
      body={termsOfService.body}
      testId="terms-of-service-page"
    />
  );
}
